module.exports = __webpack_public_path__ + "img/you-are-doing-it-right.a7d38ba6.png";